import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { HStack, Primitive, sizes, useTheme } from '@rtkwlf/fenrir-react';

import { useLegacyCapabilities } from '@apis/rendall/queries/use-capabilities';
import { useSubscriptions } from '@apis/rendall/queries/use-subscriptions';
import { Navigation } from '@packages/components/navigation/navigation';
import { NavigationItemSkeleton } from '@packages/components/navigation/navigation-item-skeleton/navigation-item-skeleton';

import { useNavData } from '../use-nav-data/use-nav-data';

export const DashboardNavigation: React.FC = () => {
  const theme = useTheme();
  const isDarkMode = theme?.themeMode === 'dark';

  const menuData = useNavData();

  const { isLoading: isSubscriptionsLoading } = useSubscriptions();
  const { isLoading: isLegacyCapabilitiesLoading } = useLegacyCapabilities();

  const isLoading = isSubscriptionsLoading || isLegacyCapabilitiesLoading;

  const items = useMemo(() => {
    return menuData.filter((item) => item.text);
  }, [menuData]);

  return (
    <Primitive.nav
      display="flex"
      alignItems="flex-end"
      borderWidth="zero"
      borderBottomWidth="default"
      borderColor="neutralDefault"
      borderStyle="solid"
      paddingX={{
        monitor: 'default',
        tablet: 'default',
      }}
      backgroundColor={
        // UX team had a decision to use the light theme brandTertiary color as navigation bar's background for both dark and light modes.
        // The change below is to make nav bar colors look the same for both theme modes
        // but still use Fenrir's colors rather than hardcoding HEX colors.
        isDarkMode ? 'brandHighlight' : 'brandTertiary'
      }
      css={css({
        '@media print': { display: 'none' },
        minHeight: sizes['3.5rem'],
      })}
    >
      {!isLoading ? (
        <Navigation items={items} />
      ) : (
        <HStack>
          <NavigationItemSkeleton />
          <NavigationItemSkeleton />
          <NavigationItemSkeleton />
          <NavigationItemSkeleton />
        </HStack>
      )}
    </Primitive.nav>
  );
};
